import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 19,
		y1: 12,
		x2: 5,
		y2: 12
	}), /* @__PURE__ */ _jsx("polyline", { points: "12 19 5 12 12 5" })]
});
export default SvgArrowLeft;
